import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import { InputRoot } from "./InputRoot";
import { generatePlaceholder } from "./utils/generatePlaceholder";

export const InputFile = forwardRef(
  (
    props: InputHTMLAttributes<HTMLInputElement>,
    ref: ForwardedRef<HTMLInputElement>,
  ) => (
    <InputRoot
      ref={ref}
      {...props}
      type="file"
      className={twMerge("w-full", props.className)}
      placeholder={generatePlaceholder(props.placeholder)}
    />
  ),
);

InputFile.displayName = "InputFile";
